<template>
  <div>
    <el-dialog
      width="674px"
      title="拒绝退款"
      :visible.sync="isRejectRefund"
      center
      :before-close="closeDone"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="cancalReject">
      <div class="form_height">
        <el-form ref="refuseRefund"  :rules="refuseRefundRules" :model="refuseRefundOptions" label-width="91px" size="mini">
          <el-form-item label="拒绝原因" prop="refuseType">
            <el-select v-model="refuseRefundOptions.refuseType" size="middle" style="width:490px" placeholder="请选择拒绝原因" @change="handleReason">
              <el-option v-for="(value,key) in refuseReasonList" :key="key" :label="value" :value="Number(key)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="refundReason" v-if="refuseRefundOptions.refuseType === 2">
            <el-input
              type="textarea"
              :rows="7"
              placeholder="请描述（必填）"
              maxlength="200"
              v-model="refuseRefundOptions.refundReason"
              show-word-limit
              class="text-area"
              style="width:490px"
             >
            </el-input>
          </el-form-item>
          <el-form-item label="上传凭证" prop="voucherDirs" >
            <!--上传视频和图片组件-->
            <el-upload :disabled="loading" action="#" :class="{stleA: refuseRefundOptions.voucherDirs.length === 0, styleB: refuseRefundOptions.voucherDirs.length >= 3}" list-type="picture-card" :on-remove='removePic'  :on-preview='preview' :on-change="(file, fileList) => {handleChange(file, fileList)}" :before-upload="file => beforeUpload(file)" accept=".jpg,.jpeg,.png,.mov,.mp4" :file-list="refuseRefundOptions.voucherDirs">
              <i v-loading.lock="loading" class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="support">支持上传JPG/PNG/JPEG/MOV/MP4格式，图片和视频大小不超过50M</div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="closeDone">取 消</el-button>
        <el-button class="true-btn" @click="rejectRefundOrder">确认拒绝</el-button>
      </span>
    </el-dialog>
    <div class="pre">
      <el-dialog :visible.sync="dialogVisible"  width="1100px">
        <div class="preview">
          <div class="close_pre"><span @click="handleClosePre" class="el-icon-circle-close"></span></div>
          <video v-if="fileVideoUrl" ref="videoPlayer" controls :src="fileVideoUrl"  style="height: 100%; object-fit: fill"> </video>
          <img class="pre_img"  v-else :src="dialogImageUrl" alt="">
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { rejectRefund, reasonRejectRefundOptions } from '@/api/order'
import { uploadFile } from '@/utils/cos'
export default {
  props: {
    row: {
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      dialogVisible: false,
      dialogImageUrl: '',
      fileList: [],
      fileVideoUrl: '',
      // 拒绝退款原因列表
      refuseReasonList: [],
      btnLoading: false,
      isRejectRefund: false,
       // （确认、拒绝）退款表单
      refuseRefundOptions: {
        refuseType: '',
        refundReason: '',
        voucherDirs: []
      },
      refuseRefundRules: {
        refuseType: [
          { required: true, message: '请选择退款原因', trigger: 'change' }
        ],
        refundReason: [
           { required: false, message: '请输入拒绝原因', trigger: 'blur' }
        ],
        voucherDirs: [
          { required: true, message: '请上传凭证', trigger: 'change' },
        ]
      },
      currTask: {} // cos传输过来的分片中断上传api
    }
  },
  methods: {
    init () {
      this.isRejectRefund = true
      this.reasonRejectRefundOptionsApi()
    },
    beforeUpload () {
      return false
    },
    // 关闭前的回调
    closeDone () {
      this.isRejectRefund = false
    },
    cancalReject () {
      this.$emit('cancalReject')
      const { cos, taskId } = this.currTask
      if (cos && taskId) {
        cos.cancelTask(taskId)
      }
    },
    // 关闭预览
    handleClosePre () {
      this.dialogVisible = false
    },
    handleReason (val) {
      this.refuseRefundRules.refundReason[0].required = val === 7
      this.refuseRefundOptions.refundReason = ''
    },
    handleChange (file) {
      this.loading = true
      const { name, size } = file.raw
      const imgSize = size / 1024
      if (imgSize > 50 * 1024) {
        this.loading = false
        return this.$message({ message: '图片或视频大小不能超过50Mb！', type: 'warning' })
      }
      // 支持上传JPG/PNG/JPEG/MOV/MP4格式，图片和视频大小大小不超过50M
      uploadFile(file.raw, name, taskRes => {
        this.currTask = taskRes
      }).then(res => {
        this.currTask = {}
        const isVideo = /^.*\.(mp4|mov)$/
        const item = { name: name, url: '' }
        // 获取后缀转小写
        const fileExtension = name.substring(name.lastIndexOf('.')).toLowerCase()
        if (isVideo.test(fileExtension)) {
          item.url = `https://${res.Location}?x-oss-process=video/snapshot,t_10000,m_fast`
        } else {
          item.url = `https://${res.Location}`
        }
        this.refuseRefundOptions.voucherDirs.push(item)
        // 有的话清除校验
        if (this.refuseRefundOptions.voucherDirs.length > 0) {
          this.$refs['refuseRefund'] && this.$refs['refuseRefund'].clearValidate('voucherDirs')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    removePic(file, fileList) {
      this.refuseRefundOptions.voucherDirs = fileList
    },
    preview (file) {
      this.dialogImageUrl = ''
      this.fileVideoUrl = ''
      this.dialogVisible = true
      // 获取后缀并且小写
      const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      const isVideo = /^.*\.(mp4|mov)$/
      if (isVideo.test(fileExtension)) {
        const url = file.url.split(file.name.substring(file.name.lastIndexOf('.')))[0]
        this.fileVideoUrl = `${url}${file.name.substring(file.name.lastIndexOf('.'))}`
      } else {
        this.dialogImageUrl = file.url
      }
    },
    rejectRefundOrder () {
      this.$refs.refuseRefund.validate((vaild) => {
        if (!vaild) return
        const { gasId, orderId, applySourceType } = this.row
        const picList = []
        const voucherDirsCopy = JSON.parse(JSON.stringify(this.refuseRefundOptions))
        voucherDirsCopy.voucherDirs.forEach(item => {
          if (item.url.indexOf('?x-oss-process=video/snapshot,t_10000,m_fast') !== -1) {
            item.url = item.url.split('?x-oss-process=video/snapshot,t_10000,m_fast')[0]
          }
          picList.push(item.url)
        })
        const params = {
          ...voucherDirsCopy,
          gasId,
          orderId,
          applySourceType,
        }
        params.voucherDirs = picList.join(',')
        this.reject(params)
      })
    },
    // 拒绝退款下拉框
    async reasonRejectRefundOptionsApi () {
      try {
        const { code, result } = await reasonRejectRefundOptions()
        if (code !== 200) return
        this.refuseReasonList = result
      } catch (error) {
        console.log(error)
      }
    },
    // 拒绝退款
    async reject (params) {
      try {
        const { code } = await rejectRefund(params)
        if (code !== 200) return
        this.$message.success('拒绝成功')
        this.isRejectRefund = false
        this.$emit('handleRejectRefund')
      } catch (error) {
        console.log(error.message)
      } finally {
        this.isRejectRefund = false
        this.reset()
        this.$emit('handleRejectRefund')
      }
    },
  }
}
</script>
<style lang="less" scoped>
.form_height{
  // padding: 20px 0 80px 0;
  height: 360px;
}
/deep/.el-dialog__footer{
  box-shadow: none !important;
}
/deep/.styleA .el-upload--picture-card{
  width:110px;
  height:110px;
  line-height:110px;
}
/deep/.styleB .el-upload--picture-card{
  display:none;
}
.pre{
  /deep/.el-dialog__header{
    display: none;
  }
 /deep/.el-dialog__body{
    padding: 0;
  }
}
/deep/.el-upload--picture-card{
  width: 100px;
  height: 100px;
  line-height: 108px;
}
/deep/.el-upload-list--picture-card .el-upload-list__item{
  width: 100px;
  height: 100px;
}
/deep/.el-upload-list--picture-card .el-upload-list__item-status-label{
  box-shadow: 0 0 0 0;
}
/deep/.el-loading-spinner{
  left: -21%;
}
.cancel-btn{
  width: 100px;
  height: 40px;
  border-radius: 2px;
  border: 1px solid #C5C9D0;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #666666;
}
.true-btn{
  width: 100px;
  height: 40px;
  text-align: center;
  background: #4B7EFE;
  box-shadow: 0px 1px 4px 0px rgba(16,67,193,0.2);
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #FFFFFF;
  text-shadow: 0px 1px 4px rgba(16, 67, 193, 0.2);
  border: none;
}
.support{
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #C3C3CF;
}
.preview{
  padding: 5px 0;
  display: flex;
  width: 100%;
  justify-content: center;
  height: 650px;
  background: #fff;
  position: relative;
  .close_pre{
    width: 30px;
    height: 30px;
    top: 20px;
    right: 30px;
    position: absolute;
    >span{
      display: block;
      font-size: 30px;
      cursor: pointer;
    }
  }
}
.pre_img{
  // width: 100%;
  // height: 100%;
}
.dialog-footer{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>